module.exports = new __parcel__URL__("Hiring Process Hover.a7af5d46.svg").toString();